import script from "./UploadChartOfAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadChartOfAccount.vue?vue&type=script&setup=true&lang=js"

import "./UploadChartOfAccount.vue?vue&type=style&index=0&id=874c0672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-874c0672"]])

export default __exports__